import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    basePath: String,
    param: String
  }

  connect() {
    this._handler = (event) => this.navigate(event)
    this._hiddenInput = this.element.querySelector(".select-hidden-input-value")
    if (this._hiddenInput) {
      this._hiddenInput.addEventListener("app-select:change", this._handler)
    }
  }

  disconnect() {
    if (this._hiddenInput) {
      this._hiddenInput.removeEventListener("app-select:change", this._handler)
    }
  }

  navigate(event) {
    const value = event.detail.value
    const url = new URL(this.basePathValue, window.location.origin)
    if (value) {
      url.searchParams.set(this.paramValue, value)
    }
    Turbo.visit(url.toString(), { action: "advance" })
  }
}
